/* @flow */
export function logger(...args: Array<mixed>): void {
  // eslint-disable-next-line
  console.log(...args);
}
